// Plain JS so TypeScript 4.8 reads identity-client.d.ts and never parses
// better-auth's own typings, which need TypeScript 5.
import { createAuthClient } from "better-auth/client"
import { jwtClient } from "better-auth/client/plugins"

export function createIdentityClient(baseURL) {
  const client = createAuthClient({
    baseURL,
    // The app waits for the first token before it boots.
    fetchOptions: { credentials: "include", timeout: 10000 },
    plugins: [jwtClient()],
  })

  return {
    async token() {
      const { data, error } = await client.token()
      if (error) {
        if (error.status === 401) {
          return null
        }
        throw new Error(`identity token request failed: ${error.status} ${error.message || ""}`.trim())
      }
      return data?.token || null
    },
    async signOut() {
      await client.signOut()
    },
  }
}
